<section class="color-background" [ngStyle]="{'direction':lang==='ar' ? 'rtl' : 'ltr' }">
  <div class="content-2">
    <div class="footer2-divider"></div>
  </div>
  <div class="w-layout-grid footer2-links-grid">
    <div id="w-node-e49d2566-f6cb-929f-d287-7516e4a90e0d-b0b3cb50" class="footer__bottom">
      <div class="footer__copyright">
        <img src="assets_main/rg22.webflow/images/sym2-light.svg" loading="eager" width="72" alt=""
          class="footer__copyright-logo" />
        <div style="color: white"> {{ 'footer-reserved' | translate:{ start:2016, end: currentYear } }}</div>
      </div>
    </div>
    <div id="w-node-_7f4a8931-1582-0123-1435-5ba12741d165-b0b3cb50"
      class="footer-bottom-res footer2-links-wrap is--hor">
      <a routerLink="/privacyPolicy" class="footer2-link is--hor">{{'Privacy-Policy'|translate}}</a>
      <a routerLink="/termsOfUse" class="footer2-link is--hor">{{'Terms-of-Use'|translate}}</a>
      <a routerLink="/contact" class="footer2-link is--hor">{{'Contact'|translate}}</a>
      <!-- <a href="{{cuedmontonLink}}" class="footer2-link is--hor" target="_blank">{{'cuedmonton'|translate}}</a> -->
      <div class="footer__social">
        <a href="https://www.facebook.com/RoboGardenInc/" target="_blank" class="footer__soc-link w-inline-block"><img
            src="assets_main/rg22.webflow/images/ico_soc-fb.svg" loading="eager" alt="" class="footer__soc-img" /></a>
        <a href="https://www.linkedin.com/company/robogarden-inc/" target="_blank"
          class="footer__soc-link w-inline-block"><img src="assets_main/rg22.webflow/images/ico_soc-in.svg" loading="eager"
            alt="" class="footer__soc-img" /></a>
        <a href="https://www.instagram.com/robogardeninc/" target="_blank" class="footer__soc-link w-inline-block"><img
            src="assets_main/rg22.webflow/images/ico_soc-inst.svg" loading="eager" alt="" class="footer__soc-img" /></a>
      </div>
    </div>
  </div>
</section>
